import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SalesPage } from './pages/SalesPage';
import { GatewayPage } from './pages/GatewayPage';
import { initFbPixel, trackPageView } from './utils/fbpixel';
export function App() {
  const [showGateway, setShowGateway] = useState(true);
  useEffect(() => {
    initFbPixel();
  }, []);
  return <AnimatePresence mode="wait" data-id="element-0">
      {showGateway ? <motion.div key="gateway" exit={{
      opacity: 0,
      scale: 1.05,
      filter: 'blur(6px)'
    }} transition={{
      duration: 0.4
    }} data-id="element-1">
          <GatewayPage onEnter={() => setShowGateway(false)} data-id="element-2" />
        </motion.div> : <motion.div key="sales" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4
    }} data-id="element-3">
          <SalesPage data-id="element-4" />
        </motion.div>}
    </AnimatePresence>;
}